import styles from '../../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import { APPROVAL_WORKFLOW_TYPES } from '../../_constants';

//this component rendered to allow user to select multi level or single level approval work flows if the selected app has no approvals implemented
const WorkFlowSelect = ({ setApprovalFlowType }) => {
	return (
		<div className={styles.ActionButtonContainer}>
			<div className={styles.border_right_1}>
				<Button
					sx={{
						border: 'none',
						'&:hover': {
							border: 'none',
						},
					}}
					onClick={() =>
						setApprovalFlowType(APPROVAL_WORKFLOW_TYPES.SingleLevel)
					}
					id='multi_level_approval_btn'
					variant='outlined'
				>
					Single Level
				</Button>
			</div>
			<Button
				onClick={() =>
					setApprovalFlowType(APPROVAL_WORKFLOW_TYPES.MultiLevel)
				}
				id='multi_level_approval_btn'
				variant='outlined'
				sx={{
					border: 'none',
					'&:hover': {
						border: 'none',
					},
				}}
			>
				Multi Level
			</Button>
		</div>
	);
};

export default WorkFlowSelect;
